export enum CoreActionTypes {
    LOAD_STATE          = '@@core/LOAD_STATE',
    LOAD_STATE_FINISHED = '@@core/LOAD_STATE_FINISHED',
}



// WEBPACK FOOTER //
// ./src/modules/core/store/types.ts